/*
 * @Author: your name
 * @Date: 2021-05-14 16:06:38
 * @LastEditTime: 2022-01-21 17:33:50
 * @LastEditors: zhujuan
 * @Description: In User Settings Edit
 * @FilePath: /nqc-pc-ui/src/apps/modules/qc-plan/plan/_api/index.js
 */

import { apiService } from '@/frameworks/http/request'
import axios from 'axios'
import store from '@/frameworks/store/index'
let prefix = 'NQCS/DoAction?act='
let HospitalCode = store.state.user.HospitalCode
export function GetZKJHList(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetZKJHList`,
    method: 'post',
    data: params
  })
}

export function GetZKJHMXList(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetZKJHMXList`,
    method: 'post',
    data: params
  })
}

export function GetCKLevelByUserId(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetCKLevelByUserId`,
    method: 'post',
    data: params
  })
}

export function GetZKJHJCPL() {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetZKJHJCPL`,
    method: 'post'
  })
}

export function SaveZKJH(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}SaveZKJH`,
    method: 'post',
    data: params
  })
}

export function PublishZKJH(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}PublishZKJH`,
    method: 'post',
    data: params
  })
}

export function CancleZKJH(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}CancleZKJH`,
    method: 'post',
    data: params
  })
}

export function DeleteZKJH(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}DeleteZKJH`,
    method: 'post',
    data: params
  })
}
/**
 * 判断当前组织结构是否有新增权限
 * @param {*} {UserId:string,Zkjb:Number}
 * @returns
 */
export function JudgeCanAddZKJH(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}JudgeCanAddZKJH`,
    method: 'post',
    data: params
  })
}
/**
 * 质控级别联动督查部门
 * @param {*} params
 * @returns
 */
export function GetCheckDepartInfoByZkjb(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetCheckDepartInfoByZkjb`,
    method: 'post',
    data: params
  })
}

/**
 * 查询组织结构接口
 * @param { obj : {UserId:'',Zkjb:''} params
 * @returns
 */
export function GetZZjgByZkjbAndUser(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetZZjgByZkjbAndUser`,
    method: 'post',
    data: params
  })
}

export function CalcPlanTask(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}CalcPlanTask`,
    method: 'post',
    data: params
  })
}

/**
 * 指控计划选择频率后生成子计划列表
 * @param {*} params
 * @returns
 */
export function AutoGenDetailPlan(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}AutoGenDetailPlan`,
    method: 'post',
    data: params
  })
}

export function Download(param) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `NQCS/Download?act=ExportZKJH`,
    method: 'post',
    responseType: 'blob',
    data: param,
    timeout: 15 * 60 * 1000
  })
}

/**
 * 获取系统配置
 * @param {*} {Mjdm，Mjlx}
 * @returns
 */
export function GetXTMJList(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetXTMJList`,
    method: 'post',
    data: params
  })
}

/**
 * 获取系统配置
 * @param {*} {Mjdm，Mjlx}
 * @returns
 */
export function GetMXJCListByZXH(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetMXJCListByZXH`,
    method: 'post',
    data: params
  })
}

/**
 * 获取组织结构成员
 * @param {*} {zzjgdm}
 * @returns
 */
export function GetZZJGCY(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetZZJGCY`,
    method: 'post',
    data: params
  })
}
// demo for form data submit
// export function getFormDetail(params) {
//   return apiCommon.postForFormData(`${prefix}/GetFormDetail`, params)
// }
